import {observer} from "mobx-react-lite";
import Btn from "../../../ui/Btn";
import {useNavigate} from "react-router-dom";
import React, {useEffect} from "react";
import clubStore from "../../../storage/ClubStore";
import appStore from "../../../storage/AppStore";
import PageLayout from '../../PageLayout'
import NumericPagination from '../../NumericPagination'
import GamesFilter from '../../Games/GamesFilter'
import GamesList from '../../Games/GamesList'

const Games = () => {
    const navigate = useNavigate()
    useEffect(() => {
        clubStore.tournament.searchGames()
    }, [])

    return (
        <PageLayout header={
          <div className="flex justify-content-between align-items-center">
            <h3 className="m-0">{appStore.tr.games}</h3>
            <div className="flex">
                    <Btn icon={"pi pi-plus"} severity={"success"}
                         onClick={() => {
                             navigate('/manager/games/create')
                         }}/>
                 </div>
          </div>
        } filters={
          <GamesFilter store={clubStore.tournament} />
        } pagination={
          <NumericPagination
              query={clubStore.tournament.gamesQuery}
              onPageChange={(page) => {
                  clubStore.tournament.gamesQuery.setProperty("page_number", page);
                  clubStore.tournament.searchGames()
              }}
          />
        }>
          <GamesList role={"MGR"} games={clubStore.tournament.games} detailsBasePath={"/manager/games/show"}/>
        </PageLayout>
    )
}
export default observer(Games)